import { render, staticRenderFns } from "./InstallationDefectedProjects.vue?vue&type=template&id=74d89ca4&scoped=true"
import script from "./InstallationDefectedProjects.vue?vue&type=script&lang=js"
export * from "./InstallationDefectedProjects.vue?vue&type=script&lang=js"
import style0 from "./InstallationDefectedProjects.vue?vue&type=style&index=0&id=74d89ca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d89ca4",
  null
  
)

export default component.exports